<div class="table-responsive list-table-box">
    <table mat-table [dataSource]="tableContent" class="table list-table" [ngClass]="customTableClass" matSort>
        @for (column of tableConfiguration; track column; let i = $index) {
            <ng-container [matColumnDef]="column.header_name">
                <th mat-header-cell *matHeaderCellDef>
                    @if (i === 0) {
                        <!-- <mat-checkbox (change)="selectOrUnselectAllRows($event)"></mat-checkbox> -->
                    }
                    {{ column.header_name }}
                </th>
                <td mat-cell *matCellDef="let element; let rowIndex = index">
                    @if (i === 0) {
                        <!-- <div class="image-icon">
								<mat-checkbox
									[ngClass]="column.column_type === columnTypeEnum.NON_EDITABLE_COLUMN_WITH_IMAGE || column.column_type === columnTypeEnum.COLUMN_CHECKBOX_WITH_IMAGE ? 'img-checkbox' : ''"
									[checked]="element.is_checked"
									(change)="selectParticularRow($event, element)"></mat-checkbox>
							</div> -->
                    }
                    @switch (column.column_type) {
                        @case (columnTypeEnum.NON_EDITABLE_COLUMN) {
                            @if (column?.toolTipConfiguration?.isRequired) {
                                <div #tooltip="matTooltip" matTooltip="{{ element[column.api_column_value] }}" matTooltipPosition="below">
                                    @if (element[column.api_column_value]?.length > 0) {
                                        {{ element[column.api_column_value] | textTruncate: column?.toolTipConfiguration?.textLength }}
                                    } @else {
                                        -
                                    }
                                </div>
                            } @else {
                                {{ element[column.api_column_value]?.length > 0 ? element[column.api_column_value] : '-' }}
                            }
                        }
                        @case (columnTypeEnum.NON_EDITABLE_COLUMN_WITH_IMAGE) {
                            <!-- <div class="image-icon">
                                @if (element[moduleName + '_image']) {
                                    <img
                                        [src]="environment.imageDownloadUrl + moduleName + '/' + element[moduleName + '_image']"
                                        alt=""
                                        [moduleName]="moduleName"
                                        [onErrorSrc]="'/assets/images/default-' + moduleName + '-img.svg'"
                                        appImageError
                                    />
                                } @else {
                                    <img [src]="'assets/images/default-' + moduleName + '-img.svg'" alt="" />
                                }
                                @if (column.toolTipConfiguration.isRequired) {
                                    <span
                                        #tooltip="matTooltip"
                                        matTooltip="{{ element[column.api_column_value] }}"
                                        matTooltipPosition="below"
                                        class="ms-2"
                                        >{{ element[column.api_column_value] | textTruncate: column.toolTipConfiguration.textLength }}</span
                                    >
                                } @else {
                                    <span class="ms-2">{{
                                        element[column.api_column_value]?.length > 0 ? element[column.api_column_value] : '-'
                                    }}</span>
                                }
                            </div> -->
                        }
                        @case (columnTypeEnum.COLUMN_CHECKBOX_WITH_IMAGE) {
                            <div class="image-icon">
                                <!-- <mat-checkbox [checked]="element.is_checked"
                    (change)="selectParticularRow($event, element)"></mat-checkbox> -->
                                <!-- @if (element[moduleName + '_image']) {
                                    <img
                                        [src]="environment.imageDownloadUrl + moduleName + '/' + element[moduleName + '_image']"
                                        class="circle-img"
                                        alt=""
                                        [moduleName]="moduleName"
                                        [onErrorSrc]="'/assets/images/default-' + moduleName + '-img.svg'"
                                        appImageError
                                    />
                                } @else {
                                    <img src="assets/images/default-profile-picture.png" class="circle-img" alt="" />
                                }
                                <span class="ms-2">{{
                                    element[column.api_column_value]?.length > 0 ? element[column.api_column_value] : '-'
                                }}</span> -->
                            </div>
                        }
                        @case (columnTypeEnum.COLUMN_WITH_DISABLE_TOGGLE_SWITCH) {
                            <mat-slide-toggle
                                [disabled]="true"
                                class="mat-slide-toggle-box"
                                [checked]="element[column.api_column_value]"
                            ></mat-slide-toggle>
                        }
                        @case (columnTypeEnum.COLUMN_WITH_ENABLE_TOGGLE_SWITCH) {
                            <mat-slide-toggle
                                [disabled]="false"
                                class="mat-slide-toggle-box"
                                [checked]="element[column.api_column_value]"
                            ></mat-slide-toggle>
                        }
                        @case (columnTypeEnum.CONVERT_EPOCH_TO_DATE) {
                            @if (+element[column.api_column_value]) {
                                {{ +element[column.api_column_value] | date }}
                            } @else {
                                -
                            }
                        }
                        @case (columnTypeEnum.COLUMN_WITH_CHIP) {
                            <mat-chip-listbox>
                                <mat-chip
                                    [ngClass]="
                                        setStatusName(column.header_name, column.column_type, element[column.api_column_value])
                                            .chipColorClass
                                    "
                                >
                                    {{ setStatusName(column.header_name, column.column_type, element[column.api_column_value]).status }}
                                </mat-chip>
                            </mat-chip-listbox>
                        }
                        @case (columnTypeEnum.ICON) {
                            <img [src]="element[column.api_column_value]" alt="camera-icon" />
                        }
                        @case (columnTypeEnum.ICON_WITH_ENABLED_DISABLED_STATUS) {
                            @if (element.reportStatusConfiguration) {
                                <button
                                    class="export-file-btn"
                                    (click)="
                                        column.isCellClickableConfiguration.isClickAllowed
                                            ? emitCellClick(column.isCellClickableConfiguration.onClickEmitEvent, element)
                                            : ''
                                    "
                                    [disabled]="element.reportStatusConfiguration.isGenerated"
                                >
                                    <mat-icon [svgIcon]="element.reportStatusConfiguration.reportFileTypeIconUrl | svgToMatIcon"></mat-icon>
                                </button>
                            }
                        }
                        @case (columnTypeEnum.ACTIONS_WITH_OPERATIONS) {
                            <button mat-button [matMenuTriggerFor]="actionMenu" class="list-action-menu-btn">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionMenu="matMenu" xPosition="before">
                                @for (list of actionList; track list) {
                                    <a mat-menu-item class="menu-sec" (click)="emitCrudOperation(list.key, element)">
                                        <mat-icon [svgIcon]="'assets/icons/list-icons/' + list.key + '.svg' | svgToMatIcon"></mat-icon>
                                        {{ list.value }}
                                    </a>
                                }
                            </mat-menu>
                        }
                    }
                </td>
            </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="tableHeader"></tr>
        <tr mat-row *matRowDef="let row; columns: tableHeader"></tr>
    </table>
</div>
@if (pagination) {
    <app-pagination [pagination]="pagination" (changedPagination)="changePagination.emit($event)"></app-pagination>
}
